import React from "react";
import { View, Text, StyleSheet, Dimensions } from "react-native";

const isMobile = Dimensions.get("window").width < 768;

const SETUP_STEPS = ["Set your goal", "Activate your Grad Fund", "Share your announcement"];

/** Empty state shown to a graduate who hasn't set a Grad Fund goal yet. Shared by the Announcement and Registry pages. */
const GradFundGoalOnboarding = () => (
	<View style={styles.container}>
		<Text style={styles.copy}>
			Whether you're headed to college, trade school, or your first apartment, friends and family can contribute toward your next chapter.
		</Text>
		<View style={styles.steps}>
			{SETUP_STEPS.map((step, index) => (
				<Text key={step} style={styles.step}>
					<Text style={styles.stepLabel}>Step {index + 1}:</Text> {step}
				</Text>
			))}
		</View>
	</View>
);

const textOnPhoto = {
	color: "#fff",
	textShadowColor: "rgba(0, 0, 0, 0.55)",
	textShadowRadius: 3.84,
};

const styles = StyleSheet.create({
	container: {
		marginBottom: 12,
		width: "100%",
	},
	copy: {
		...textOnPhoto,
		fontSize: isMobile ? 14 : 16,
		lineHeight: isMobile ? 20 : 23,
		marginBottom: 8,
	},
	steps: {
		gap: 4,
	},
	step: {
		...textOnPhoto,
		fontSize: isMobile ? 13 : 15,
		lineHeight: isMobile ? 18 : 21,
	},
	stepLabel: {
		fontWeight: "bold",
	},
});

export default GradFundGoalOnboarding;
